import styled from 'styled-components';

export const Modals = styled.div`
.modal{
  align-items: center;
  //background-color: rgba(0,0,0,.5);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  border-radius: 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
}
  .modal.show {
    opacity: 1;
  }
  .modal-content {
    background-color: #fff;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    height: 20rem;
    justify-content: space-between;
    padding: 20px;
    width: 500px;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    animation: scaleUp .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    
  }
  .close-btn{
    float: right;
    font-size: 40px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    opacity: 1;
    appearance: none;
    border-radius: 100%;
    width: 40px;
    height: 40px;
    color: black;
    font-weight: 100;
    box-shadow: 0px 0px 0px 0px transparent!important;
    transition: box-shadow 0.1s ease , color 0.1s linear;
    background:transparent!important;
  }
  .close-btn:hover{
    box-shadow: 0px 0px 0px 2.5px!important;
    color:red;
  }
  @keyframes scaleUp {
    0% {
      transform:scale(.8) translateY(1000px);
      opacity:0;
    }
    100% {
      transform:scale(1) translateY(0px);
      opacity:1;
    }
  }
`;
